import type { ChangelogEntry } from "../types";

/** Chat-rom på /chat: kanaler for prosjekter, hele huset og direktemeldinger. */
export const CHAT_ROM_2026_10: ChangelogEntry = {
  id: "2026-10-28-chat-rom",
  date: "2026-10-28",
  title: "Chat får egen side med kanaler",
  summary: "Chat er nå en egen side i menyen med kanaler for prosjekter, hele huset og direktemeldinger. Den erstatter den flytende chatten nede til høyre.",
  sections: [
    {
      heading: "Chat",
      items: [
        {
          title: "Chat i menyen med antall uleste",
          kind: "nytt",
          featureFlag: "feature_chat_rom",
          body: "«Chat» ligger i sidemenyen og viser hvor mange uleste meldinger du har. Kanalene er gruppert i Prosjekter, Huset og Direkte, og du kan søke etter kanal eller person. Når Chat er slått på for deg, forsvinner den flytende chat-knappen.",
        },
        {
          title: "Prosjektkanaler er samme strøm som Prosjektoppdateringer",
          kind: "nytt",
          featureFlag: "feature_chat_rom",
          body: "Under Prosjekter ligger de aktive og kommende prosjektene der du er produksjonsleder, eier, tildelt timer, har skrevet eller er nevnt. Det du skriver i kanalen havner i Prosjektoppdateringer på prosjektkortet, og omvendt. «Åpne i Chat» på Prosjektoppdateringer tar deg rett til kanalen.",
        },
        {
          title: "Hendelser i prosjektkanalen",
          kind: "nytt",
          featureFlag: "feature_chat_rom",
          body: "Prosjektkanalen viser når prosjektet flyttes til ny fase, når en oppgave fullføres eller godkjennes, og når noen registrerer timer. Meldingene kommer fra Revehiet, lenker til prosjektkortet eller budsjettet, og teller ikke som uleste.",
        },
        {
          title: "AI-oppsummering av det du har gått glipp av",
          kind: "nytt",
          featureFlag: "feature_chat_rom",
          body: "Har en kanal uleste meldinger, kan du klikke «Oppsummer N uleste». Da får du de viktigste punktene og det som venter på deg. Bare meldingene du ikke har lest tas med, og ingen meldingstekst lagres.",
        },
        {
          title: "Kostnaden for AI-oppsummering under Drift",
          kind: "nytt",
          featureFlag: "feature_chat_rom",
          minRole: "admin",
          body: "Under Innstillinger → Drift → Systemhelse viser et eget kort hva oppsummeringene har kostet per måned, hvor mange som er laget og av hvor mange.",
        },
        {
          title: "Hele Sølvrev, en kanal for alle ansatte",
          kind: "nytt",
          featureFlag: "feature_chat_rom",
          body: "Alle ansatte er med i kanalen «Hele Sølvrev» under Huset. Nyansatte blir med automatisk første gang de åpner Chat.",
        },
        {
          title: "Reaksjoner på meldinger",
          kind: "nytt",
          featureFlag: "feature_chat_rom",
          body: "Gi 👍, 🎉 eller 👀 på en melding. Klikk på en reaksjon for å ta den bort igjen. 👍 på en melding i en prosjektkanal er det samme som en like i Prosjektoppdateringer.",
        },
        {
          title: "@-nevning med varsel",
          kind: "nytt",
          featureFlag: "feature_chat_rom",
          body: "Skriv @ for å nevne en kollega. Den du nevner får et varsel som åpner kanalen, og kanalen får et @-merke i listen til meldingen er lest. Varselet «Nevnt i Chat» kan slås av under Innstillinger → Varsler.",
        },
        {
          title: "Strek ved nye meldinger",
          kind: "nytt",
          featureFlag: "feature_chat_rom",
          body: "Når du åpner en kanal, viser en rød strek hvor de uleste meldingene starter. Enter sender meldingen, Shift+Enter gir linjeskift, og du kan legge ved filer som før.",
        },
      ],
    },
  ],
};
